import { useEffect } from "react";

const trackWithStackAdaptPixel = (
    stackAdaptPixelId?: string,
    eventName?: string,
    parameters?: Record<string, unknown>
) => {
    if (window.saq && stackAdaptPixelId) {
        window.saq("ts", stackAdaptPixelId, {
            ...parameters,
            eventName: eventName ?? "UnknownEvent"
        });
    } else {
        console.warn(
            "StackAdapt Pixel is not initialized. Cannot track event."
        );
    }
};

const useStackAdaptPixel = ({
    stackAdaptPixelId
}: {
    stackAdaptPixelId: string | undefined;
}) => {
    useEffect(() => {
        if (window.saq) {
            console.log(
                "StackAdapt Pixel is already initialized. Skipping initialization."
            );
            return;
        }

        if (stackAdaptPixelId) {
            console.log(
                "Initializing StackAdapt Pixel with id = ",
                stackAdaptPixelId
            );

            // https://www.stackadapt.com/universal-pixel/conversion
            const script = document.createElement("script");
            script.innerHTML = `
                !function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('ts', '${stackAdaptPixelId}');
            `;
            script.id = "stack-adapt-pixel-script";
            document.head.appendChild(script);

            return () => {
                if (document.head.contains(script)) {
                    document.head.removeChild(script);
                }
            };
        } else {
            console.log(
                "StackAdapt Pixel id is not set. Skipping initialization."
            );
        }
    }, [stackAdaptPixelId]);

    return { trackWithStackAdaptPixel };
};

export { useStackAdaptPixel, trackWithStackAdaptPixel };
